import { Locales } from '../strings/Locales.js';
var getCurrentApplicationName = function getCurrentApplicationName() {
    return __APP_NAME__;
};
var LOCALIZED_APPLICATION_NAME_MAP = {
    'admin-ui': Locales.format('applications.platform.label'),
    'commerce-hub': Locales.format('applications.commerceHub.label'),
    docs: Locales.format('applications.docs.label'),
    'knowledge-hub': Locales.format('applications.knowledgeHub.label')
};
var getCurrentApplicationNameLocalized = function getCurrentApplicationNameLocalized() {
    var currentApplicationName = getCurrentApplicationName();
    return LOCALIZED_APPLICATION_NAME_MAP[currentApplicationName];
};
var APPLICATION_ID_MAP = {
    'admin-ui': 'AdminConsole',
    'commerce-hub': 'CommerceHub',
    docs: 'UIDocsHub',
    'knowledge-hub': 'KnowledgeHub'
};
var getCurrentApplicationClientId = function getCurrentApplicationClientId() {
    var currentApplicationName = getCurrentApplicationName();
    return APPLICATION_ID_MAP[currentApplicationName];
};
export var ApplicationHelper = {
    getCurrentApplicationClientId: getCurrentApplicationClientId,
    getCurrentApplicationName: getCurrentApplicationName,
    getCurrentApplicationNameLocalized: getCurrentApplicationNameLocalized
};

//# sourceMappingURL=ApplicationHelper.js.map